import React, { useEffect, useState } from "react";
import {
  CancelButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  getAllVendors,
  updateBrand,
  updateVendor,
} from "../../../redux/features/assetManagementSlice";

const UpdateVendor = ({ rowData, dispatchParams }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.assetmanagement);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: rowData.name,
      phoneNumber: rowData.phoneNumber,
      email: rowData.email,
      address: rowData.address,
      place: rowData.place,
      gst: rowData.gst,
      vendorID: rowData.vendorID,
      vendorStatus: 0,
    },
    onSubmit: (values) => {
      dispatch(updateVendor(values)).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getAllVendors(dispatchParams));
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  const vendorstatus = [
    { id: 0, name: "Active" },
    { id: 1, name: "Inactive" },
    { id: 2, name: "Deleted" },
  ];

  return (
    <GlobalDialog
      title={"Update Vendor"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"md"}
      closeButton={true}
      popupButton={
        <UpdateButton size="medium" action={() => setOpen(true)}>
          Update
        </UpdateButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Vendor Name"
                  />
                  <TextField
                    name="phoneNumber"
                    value={formik.values.phoneNumber}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Phone Number"
                  />
                  <TextField
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Email ID"
                  />
                  <TextField
                    name="address"
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Address"
                  />
                  <TextField
                    name="place"
                    value={formik.values.place}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Place"
                  />
                  <TextField
                    name="gst"
                    value={formik.values.gst}
                    onChange={formik.handleChange}
                    fullWidth
                    label="GST Number"
                  />
                  {/* <GlobalSelectField
                    options={{
                      formik,
                      name: "vendorStatus",
                      label: "Status",
                      data: vendorstatus,
                      keys: {
                        id: "id",
                        value: "name",
                      },
                    }}
                  /> */}
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <UpdateButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Update"}
                    </UpdateButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default UpdateVendor;
